import api from 'services/api';
import { convertDateWithTimezoneToUTC } from 'utils/utils';
import { ZERO_TIME } from 'utils/constants';
import { DeleteEventType, EditEventProps } from './types';

export const updateEvent = ({ values, id }: EditEventProps) => {
	const newDates = values.dates.map(({ start_date, end_date }) => ({
		start_date: convertDateWithTimezoneToUTC(start_date, values.timezone),
		end_date: convertDateWithTimezoneToUTC(end_date, values.timezone),
	}));

	const selling_time =
		values.selling_time === ZERO_TIME
			? null
			: convertDateWithTimezoneToUTC(new Date(values.selling_time ?? ''), values.timezone);

	const custom_fees = values.custom_fees?.map(({ taxable, general, ...rest }) => ({
		...rest,
		taxable: taxable === '1',
		general: general === '1',
	}));

	const payload: any = {
		name: values.name,
		event_days: newDates,
		street_address: values.location,
		description: values.description,
		gate_time: values.gate_time === '' ? null : Number(values.gate_time),
		selling_time,
		postal_code: values.postal_code,
		ticketing_mode: values.ticketing_mode,
		custom_fees,
		custom_email_message: values.custom_email_message,
		support_contact: [{ contact: values.support }],
		time_zone: values.timezone,
		venue: values.venue,
		quantity: parseInt(values.quantity),
		approval_required: values.approval_required,
		on_sale: values.on_sale ?? true,
	};

	// Lógica de contraseña según backend:
	// - Campo no existe → No tocar contraseña
	// - Campo existe con null → Quitar contraseña
	// - Campo existe con "" → Ignorar
	// - Campo existe con valor → Cambiar/agregar contraseña

	if (values.remove_password) {
		// Usuario quiere remover la contraseña (toggle apagado)
		payload.password = null;
	} else if (values.want_to_change_password && values.password) {
		// Usuario quiere cambiar la contraseña existente
		payload.password = values.password;
	} else if (values.change_password && values.password) {
		// Usuario quiere agregar contraseña a un evento sin contraseña
		payload.password = values.password;
	}
	// Si no se cumplen las condiciones anteriores, no incluir el campo password (mantener la contraseña actual)

	// Lógica de hidden_until:
	// - Si hide_event es false → enviar null para quitar restricción
	// - Si hide_event es true y hay fecha → enviar la fecha
	if (values.hide_event && values.hidden_until) {
		payload.hidden_until = convertDateWithTimezoneToUTC(values.hidden_until, values.timezone);
	} else if (values.hide_event === false) {
		payload.hidden_until = null;
	}

	return api.put(`/events/${id}`, payload);
};

export const deleteEvent = ({ id }: DeleteEventType) => api.delete(`/events/${id}`);
